module.exports = __webpack_public_path__ + "media/images/p-mypageIdentificationTabBar/gray_check-c86e46db3c5d46eb0467290014510382.svg";